import { initializeCatCompanions } from "./cat-companions";
import { initializeFerretPopups } from "./ferret-popups";
import { loadConfiguredVtsModel } from "../vts-config";
import "./cat-companions.css";
import "./ferret-popups.css";
import "./pet-layer.css";

let isInitialized = false;

export async function initializeConfiguredAddons(): Promise<void> {
  if (isInitialized) {
    return;
  }
  isInitialized = true;

  const { app } = await loadConfiguredVtsModel();
  initializeFerretPopups(app.addons?.ferretPopups);
  initializeCatCompanions(app.addons?.catCompanions);
}
